import { render, staticRenderFns } from "./Addpersondialog.vue?vue&type=template&id=c901c2a0"
import script from "./Addpersondialog.vue?vue&type=script&lang=js"
export * from "./Addpersondialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports